import { routerHelpers } from "@thegetty-private/rad-app-utils";
import { getRouteNameFromIndexedId } from "@/helpers/Router";

/**
 * Inserts <i> tags into the displayed suggestion string to show the type
 * that the match is (e.g. (Title), (Person))
 *
 * @param {String} text - The current (match) string
 * @param {Object} suggestionObject - The matched result's details
 * @param {Function} translatePart - The Translate Part function
 *
 * @returns {String}
 */
export function addSuffix(text, suggestionObject, translatePart) {
  if (!suggestionObject) {
    return `${text} <i>${translatePart("a-guiautocomplete.keyword")}</i>`;
  }

  if (suggestionObject.type == "HumanMadeObject") {
    return `${text} <i>${translatePart("a-guiautocomplete.title")}</i>`;
  } else if (suggestionObject.type == "Person") {
    let displayText = `${text} <i>${translatePart(
      "a-guiautocomplete.person"
    )}</i>`;

    if (suggestionObject.description) {
      displayText = `${displayText}, <span>${suggestionObject.description}</span>`;
    }

    return displayText;
  } else if (suggestionObject.type == "Group") {
    return `${text} <i>${translatePart("a-guiautocomplete.group")}</i>`;
  }

  return text;
}

/** Event to be triggered instead of an autocomplete search event
 *
 * @param {Object} event - details of the selected suggestion that is passed
 * through the event
 * @param {router} router - the vue router
 */
export function autocompleteEntry(event, router) {
  let suggestionObject = event.object;
  const slug = routerHelpers.getSlugFromSlugWithPath(
    suggestionObject.slug_with_path
  );

  // build route to object
  let routeTo = {
    name: getRouteNameFromIndexedId(suggestionObject.id),
    state: {
      indexedId: suggestionObject.id,
      slug: slug
    },
    params: {
      slug: slug
    }
  };

  router.push(routeTo);
}
